import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const timeSignatureOptions = [
    "2/2", "2/4", "3/2", "3/4", "4/2", "4/4", "5/4", "6/4", 
    "3/8", "6/8", "7/4", "7/8", "9/8", "12/4", "12/8"
];

const ArrangementModal = ({ show, onHide, arrangement, onSave, isNew }) => {
    const [formData, setFormData] = useState({ name: '', key: '', bpm: '', time_signature: '' });

    useEffect(() => {
        if (show) {
            if (isNew) {
                setFormData({ name: '', key: '', bpm: '', time_signature: '4/4' });
            } else if (arrangement) {
                setFormData({
                    name: arrangement.name || '',
                    key: arrangement.key || '',
                    bpm: arrangement.bpm || '',
                    time_signature: arrangement.time_signature || '4/4',
                });
            }
        }
    }, [show, arrangement, isNew]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const dataToSend = {
            ...formData,
            bpm: formData.bpm ? parseInt(formData.bpm, 10) : null,
        };
        onSave(dataToSend);
    };

    return (
        <Modal show={show} onHide={onHide} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title>{isNew ? 'Добавить аранжировку' : 'Редактировать аранжировку'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Название</Form.Label>
                        <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} required />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Тональность</Form.Label>
                        <Form.Control type="text" name="key" value={formData.key} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Темп (BPM)</Form.Label>
                        <Form.Control type="number" name="bpm" value={formData.bpm} onChange={handleChange} min="1" />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Размер</Form.Label>
                        <Form.Select name="time_signature" value={formData.time_signature} onChange={handleChange}>
                            {timeSignatureOptions.map(ts => (
                                <option key={ts} value={ts}>{ts}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Button variant="success" type="submit" className="w-100">
                        {isNew ? 'Добавить и закрыть' : 'Сохранить изменения'}
                    </Button>
                </Form>
                {isNew && (
                    <p className="text-muted mt-3">После создания аранжировки вы сможете загрузить в нее файлы.</p>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ArrangementModal;
